import { Button, Text } from "@flat-ui";
import { TableCell, TableRow } from "@mui/material";
import { DevPageItem } from "@components/dev-features-dialog/dev-pages";

interface DevPagesTableRowProps {
  /** The page item to display in the row */
  item: DevPageItem;
}

/**
 * @returns A row of the Pages table that lets the user navigate to a page
 */
export function DevPagesTableRow({
  item,
}: DevPagesTableRowProps): React.JSX.Element {
  return (
    <TableRow key={item.label}>
      <TableCell
        sx={{
          "&.MuiTableCell-root": {
            pl: "12px",
          },
        }}
      >
        <Text variant="heading12">{item.label}</Text>
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Text variant="helpText">{item.description}</Text>
      </TableCell>
      <TableCell sx={{ p: 1, textAlign: "center" }}>
        <Button variant="secondary" onClick={item.onOpen} size="s">
          Open
        </Button>
      </TableCell>
    </TableRow>
  );
}
